import DrawingEditor from '@/components/drawing/DrawingEditor.tsx'
// import useDrawingTemplates from '@/hooks/useDrawingTemplates.tsx'
// import { useDrives } from '@/stores/useDrives.ts'

export default function DriveCardEditorPage() {
  // const { currentDrive } = useDrives()
  // const initialCanvas: InitialCanvas = {
  //   template: drawingTemplates[0],
  //   initialElements: [{
  //     elementId: '_fs-qrcode',
  //     imageUrl: currentDrive!.qr_code_image!
  //   }]
  // }

  // return <DrawingEditor initialCanvas={initialCanvas} />
  return <DrawingEditor />
}
